import React from 'react';
import { Route, Routes, Navigate, Link } from 'react-router-dom';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

import { ConnectedUserContext } from '../connectedUser-context';

import Axios from 'axios';
import moment from 'moment';

// MASTER components
import AdminMaster from './AdminMaster';
import QvneaAdmin from './customers/QvneaAdmin';
import AdminLocations from './Admin_Locations'
import TeamsAdmin from './teams/TeamsAdmin';
import Admin_Dev from './Admin_Dev';


// Refs:  React router and tabs
// https://github.com/reactstrap/reactstrap/issues/83#issue-168537815
// https://github.com/reactstrap/reactstrap/issues/298
// https://codesandbox.io/s/github/browniefed/tmp/tree/reactRouterDynamicRoutes/?from-embed
// https://stackoverflow.com/questions/51203888/reactjs-routing-to-different-tabs

// ADMIN MAINTENANCE SPECIAL CONSTANT
const ADMIN_MAINTENANCE_RESTRICTED_TO_MASTER = false;


class AdminGeneral extends React.Component {

	static contextType = ConnectedUserContext;

  constructor(props) {
		super(props);
		this.state = {
			activeTab: 'master',
		};
	
		this.toggle = this.toggle.bind(this);
	}

	toggle(tab) {
		if (this.state.activeTab !== tab) {
			this.setState({ activeTab: tab });
		}
	}

	render() {
		console.log('Admin_General: render');
		console.log(this.props)

    const { connectedUser } = this.context;
		if (!connectedUser) {	return;	}

		return (
			<div>
				<div className="row row-align-items-flex-end">
					<div className="col-md-12 col-12 row-margin-bottom-20">
						<p>* Pour une utilisation optimale de Statelo en mode Administrateur, utiliser le navigateur Google Chrome que vous pouvez télécharger ici</p>
	        	<a href={'https://www.google.fr/intl/fr/chrome/'} target="_blank">
			        <input type="button" className="btn btn-primary btn-sm db-menu-padsides" value="Télécharger Google Chrome" />
	        	</a>
					</div>
				</div>

				{/* ----------------- TAB CONTAINER ---------------- */}
				<div className="row">
					<div className="col-md-12">
					<div className="card card-accent-success">
					<div className="card-block">
					<Nav tabs>

						{(connectedUser.isMasterAdmin) && 
						<NavItem>
							<NavLink
								active={this.state.activeTab === 'master'}
								onClick={() => { this.toggle('master'); }}>
								MASTER
							</NavLink>
						</NavItem>}

						{(connectedUser.isMasterAdmin) && 
						<NavItem>
							<NavLink 
								active={this.state.activeTab === 'qvneaAdmin'}
								onClick={() => { this.toggle('qvneaAdmin'); }}>
								QVNEA
							</NavLink>                        
						</NavItem>}

						{(connectedUser.isMasterAdmin) && 
						<NavItem>
							<NavLink
								active={this.state.activeTab === 'locations'}
								onClick={() => { this.toggle('locations'); }}>
								Lieux
							</NavLink>                        
						</NavItem>}

						{(connectedUser.isMasterAdmin) && 
						<NavItem>
							<NavLink 
								active={this.state.activeTab === 'teams'}
								onClick={() => { this.toggle('teams'); }}>
								Équipes
							</NavLink>                        
						</NavItem>}

						{(connectedUser.isMasterAdmin) && 
						<NavItem>
							<NavLink
								active={this.state.activeTab === 'dev'}
								onClick={() => { this.toggle('dev'); }}>
								DEV
							</NavLink>
						</NavItem>}
					</Nav>

					{/* ----------------- TAB CONTENT - ROUTER ---------------- */}
					<TabContent activeTab={this.state.activeTab}>
					<TabPane tabId={this.state.activeTab}>
						{this.renderTabContent()}
					</TabPane>
					</TabContent>
				</div>
				</div> 
				</div>
				</div>
				<br/>
			</div>
		)
	}

  renderTabContent() {
    const { activeTab } = this.state;
    switch (activeTab) {
      case 'master':
        return <AdminMaster />;

      case 'qvneaAdmin':
        return <QvneaAdmin />;

      case 'locations':
        return <AdminLocations />;

      case 'teams':
        return <TeamsAdmin />;

      case 'dev':
        return <Admin_Dev />;

      default:
        return <div>Section inconnue</div>;
    }
  }

};

export default AdminGeneral;
